import { authConfig } from "../apiConfig";



export const get_roles_with_out_pagination = async () => {
  try {
    const response = await authConfig.post(`getroleList`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_roles_with_pagination = async (data) => {
  try {
    const response = await authConfig.post(`getroleList`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_role_by_id = async (data) => {
  try {
    const response = await authConfig.post(`roleviewById`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const role_creation = async (data) => {
  try {
    const response = await authConfig.post(`roleCreate`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const role_update = async (data) => {
  try {
    const response = await authConfig.post(`roleUpdate`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const role_deletion = async (data) => {
  try {
    const response = await authConfig.post(`roleDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};